import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Environments, RecurrenceScheduleItem, UpdateScheduleInstance } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../reducer/CombineReducer";
import { ProgressSpinnerSlice } from "../../../ProgressSpinner/Index";
import { CreateScheduleSlice } from "../CreateSchedule/redux";
import { SchedulingModes } from "../CreateSchedule/redux/Types";
import { handleException } from "../../../../ErrorMessages/helper";
import { useUser } from "../../../../AuthContext";
import { GetValidDateFormat } from "../Helper/Script";
import { SchedulingPopupView } from "./SchedulingPopup.view";

interface SchedulingPopupProps {
  /**
   * Title for the dialog box
   */
  title: string;
}

/**
 * Responsible for scheduling popup logic
 */
export const SchedulingPopup: React.FC<SchedulingPopupProps> = (props: SchedulingPopupProps) => {
  const { title } = props;
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const { enableSchedulingPopupSave, schedulingRecurrenceItem, schedulingDetails } = scheduling;
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  /**
   * Hide popup on close
   */
  const onClose = (): void => {
    dispatch(CreateScheduleSlice.actions.setShowSchedulingPopup(false));
  };

  /**
   * Reload scheduling list after saving recurrence item
   */
  const onSave = async (): Promise<void> => {
    try {
      dispatch(CreateScheduleSlice.actions.setShowSchedulingPopup(false));
      dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.UpdateScheduleInstance")));

      const payload: RecurrenceScheduleItem = {
        executionDateParameters: {
          relativeRunDate: GetValidDateFormat(new Date(schedulingRecurrenceItem?.relativeRunDate)) + ".000000",
          rpsd: GetValidDateFormat(new Date(schedulingRecurrenceItem?.reportingPeriodStartDate)) + ".000000",
          rped: GetValidDateFormat(new Date(schedulingRecurrenceItem?.reportingPeriodEndDate)) + ".000000",

        },
        output_configs: [{
          outputConfigGuid: schedulingRecurrenceItem?.outputConfigId,
          surveyName: schedulingRecurrenceItem?.surveyName
        }],
        isActive: schedulingRecurrenceItem?.isActive
      };

      const newResponse = await UpdateScheduleInstance(
        schedulingDetails?.scheduleGuid || "",
        schedulingRecurrenceItem?.extractScheduleInstanceId,
        payload,
        env,
        user?.token
      );

      if (newResponse) {
        dispatch(CreateScheduleSlice.actions.setScheduleListPage(true));
        dispatch(CreateScheduleSlice.actions.seSchedulingMode(SchedulingModes.VIEW));
        dispatch(CreateScheduleSlice.actions.setUpdatedScheduleInstance(newResponse["data"]["payload"]));
        dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
      }
    } catch (ex) {
      handleException(ex, dispatch, "UpdateExtractScheduleInstanceErrMsg");
    }
  };

  return (
    <SchedulingPopupView
      title={title}
      onCloseDialog={onClose}
      onSaveDialog={onSave}
      isSaveEnabled={enableSchedulingPopupSave}
    />
  );
};
